export default __webpack_public_path__ + "static/media/sweet-3.f1a1ec39.png";